import { Button } from "@msuite/ui/button";
import { Icon } from "@msuite/ui/icons";
import type { MergeProjectSchema } from "@msuite/utils/schemas";
import type { Nullable } from "@msuite/utils/types";
import { useFormContext, useWatch } from "react-hook-form";
import { ProjectCardId } from "@/components/cards";

/** Props Interface */
interface MergePreviewProps {
	sourceProjectId: Nullable<string>;
	targetProjectId: Nullable<string>;
}

export function MergePreview({ sourceProjectId, targetProjectId }: MergePreviewProps) {
	/** Context */
	const methods = useFormContext<MergeProjectSchema>();
	const direction = useWatch({ control: methods.control, name: "direction" });

	/** Render */
	if (!sourceProjectId || !targetProjectId) {
		return null;
	}

	if (sourceProjectId === targetProjectId) {
		return null;
	}

	/** Functions */
	function handleOnToggleDirection() {
		methods.setValue(
			"direction",
			direction === "source_to_target" ? "target_to_source" : "source_to_target",
		);
	}

	return (
		<div className="v-stack">
			<div className="v-stack">
				<p className="label">Source</p>
				<ProjectCardId projectId={sourceProjectId} />
			</div>
			<Button
				className="h-stack py-8"
				onClick={handleOnToggleDirection}
				variant="ghost"
				icon={
					<Icon
						name={direction === "source_to_target" ? "ChevronsDown" : "ChevronsUp"}
						size={18}
					/>
				}
				data-cy="merge-project-toggle-direction-button"
			/>
			<div className="v-stack">
				<p className="label">Target</p>
				<ProjectCardId projectId={targetProjectId} />
			</div>
		</div>
	);
}
